export default __webpack_public_path__ + "static/logo-355bab4284b61220d12c71ccdbdec40c.png";